import { makeVar } from '@apollo/client';

export const ERROR_POLICY = 'all';
export const selectedDealerId = makeVar<string>('');
export const statusChecked = makeVar({
  isNoVehicle: false,
  isNoPimData: false,
  isNoFactoryCode: false,
});
export const enablePreSelection = makeVar<boolean>(false);
export const usedCar = makeVar<boolean>(false);
